module.exports = __webpack_public_path__ + "static/media/icon_imageadd.6483ee5c.svg";